import { render } from "./slideshow-carousel.vue?vue&type=template&id=0f180a2c"
import script from "./slideshow-carousel.vue?vue&type=script&lang=js"
export * from "./slideshow-carousel.vue?vue&type=script&lang=js"

import "./slideshow-carousel.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__